// extracted by mini-css-extract-plugin
export default {"saveSupplierButton":"ihGEBDvnAv5FzdB6EVK4__saveSupplierButton___","bookmarkButton":"DulER6RKVHrArE6gMhZt__bookmarkButton___","caretDown":"u2Ay5AQuCbUTDjZdVim6__caretDown___"};